import React from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, ArrowRight, RotateCcw } from "lucide-react";

// Post-signup success view shown in place of the form after a successful
// /api/signups POST. Gives the new member a clear next step: open the
// private community page.
const SignupSuccess = ({
  firstName,
  alreadyMember,
  onSignAnother,
  variant = "light", // "light" (on white card) | "on-dark" (on dark bg)
}) => {
  const isDark = variant === "on-dark";

  const headingClass = isDark
    ? "ht-display text-2xl sm:text-3xl text-white leading-tight"
    : "ht-display text-2xl sm:text-3xl text-[#2c3e50] leading-tight";
  const bodyClass = isDark
    ? "mt-3 ht-body text-white/85 leading-relaxed"
    : "mt-3 ht-body text-[#5a6b7d] leading-relaxed";
  const checkWrap = isDark
    ? "inline-flex h-12 w-12 items-center justify-center rounded-full bg-white/15 text-[#cfe7f8]"
    : "inline-flex h-12 w-12 items-center justify-center rounded-full bg-[#eaf4fb] text-[#3d6486]";
  const secondaryBtn = isDark
    ? "ht-btn inline-flex items-center justify-center gap-2 rounded-md bg-white/10 hover:bg-white/15 border border-white/20 text-white px-4 py-2.5 text-sm font-semibold"
    : "ht-btn inline-flex items-center justify-center gap-2 rounded-md bg-white border border-[#dbe3eb] hover:border-[#cfe7f8] text-[#3d6486] px-4 py-2.5 text-sm font-semibold";

  const greeting = firstName ? `, ${firstName}` : "";
  const headline = alreadyMember
    ? `Welcome back${greeting}.`
    : `You're in${greeting}.`;
  const body = alreadyMember
    ? "Take the door into the community below — your conversations are waiting."
    : "We've saved a quiet seat for you. Step into the community whenever you're ready.";

  return (
    <div className="text-center">
      <div className="flex items-center justify-center">
        <span className={checkWrap}>
          <CheckCircle2 className="h-6 w-6" />
        </span>
      </div>
      <h3 className={`mt-4 ${headingClass}`}>{headline}</h3>
      <p className={bodyClass}>{body}</p>

      <div className="mt-6 flex flex-col sm:flex-row gap-3 sm:justify-center">
        <Link
          to="/community"
          className="ht-btn inline-flex items-center justify-center gap-2 rounded-md bg-[#b6dcf3] hover:bg-[#a4d1ee] text-[#2c3e50] font-semibold px-5 py-3 text-[15px]"
        >
          Go to Community
          <ArrowRight className="h-4 w-4" />
        </Link>
        {typeof onSignAnother === "function" && (
          <button
            type="button"
            onClick={onSignAnother}
            className={secondaryBtn}
          >
            <RotateCcw className="h-4 w-4" />
            Sign up another
          </button>
        )}
      </div>

      <p
        className={`mt-4 text-xs ${
          isDark ? "text-white/60" : "text-[#7e8a96]"
        }`}
      >
        On the community page, sign in with the email you just used.
      </p>
    </div>
  );
};

export default SignupSuccess;
